document.addEventListener('DOMContentLoaded', function() {
  var markers = document.querySelectorAll('.feature-marker');
  markers.forEach(function(marker) {
    var x = marker.getAttribute('data-x');
    var y = marker.getAttribute('data-y');
    marker.style.left = x + '%';
    marker.style.top = y + '%';
  });

  function getScope(element) {
    return element.closest('.product-description') || element.closest('.grid') || document;
  }

  function handleHover(element, isEntering) {
    var scope = getScope(element);
    var featureId = element.getAttribute('data-feature-id');
    var marker = scope.querySelector('.feature-marker[data-feature-id="' + featureId + '"]');
    var featureItem = scope.querySelector('.feature-item[data-feature-id="' + featureId + '"]');

    if (isEntering) {
      if (marker) marker.classList.add('highlight');
      if (featureItem) featureItem.classList.add('highlight');
    } else {
      if (marker) marker.classList.remove('highlight');
      if (featureItem) featureItem.classList.remove('highlight');
    }
  }

  markers.forEach(function(marker) {
    marker.addEventListener('mouseenter', function() { handleHover(marker, true); });
    marker.addEventListener('mouseleave', function() { handleHover(marker, false); });
  });

  var featureItems = document.querySelectorAll('.feature-item');
  featureItems.forEach(function(item) {
    item.addEventListener('mouseenter', function() { handleHover(item, true); });
    item.addEventListener('mouseleave', function() { handleHover(item, false); });
  });
});
